const BottomNavigation = {
  Home: 'Hem',
  organization: 'Bigårdar',
  notes: 'Anteckningar',
  IoT: 'IoT',
  errorNoIoT: 'Du har inga kopplade IoT-kupor!'
}

export default BottomNavigation
